import { Getters } from 'vuex-smart-module';
import CompaniesUsersManagersState from './state';

export default class CompaniesUsersManagersGetters extends Getters<CompaniesUsersManagersState> {}
